<script lang="ts" setup>
const requestMetaStore = useRequestMetaStore()
const stepsStore = useStepsStore()
</script>

<template>
  <div
    data-component-stepper-footer
    class="z-40 flex flex-wrap items-center justify-between gap-6 rounded border border-grey-100 bg-white p-4 sm:items-center sm:gap-10 sm:px-6 sm:py-4 md:sticky md:bottom-2"
  >
    <Button
      :link="stepsStore.previousStep?.path"
      class="w-full sm:w-fit"
      :class="!stepsStore.hasPreviousStep && 'hidden sm:invisible sm:flex'"
    >
      <template #icon-before>
        <IconArrowLeft />
      </template>
      Zurück
    </Button>

    <Button
      v-if="stepsStore.currentStep?.meta.step.allowSave"
      :link="stepsStore.getChildPath('speichern')"
      :theme="requestMetaStore.finalized ? 'default' : 'text'"
      class="order-1 w-full text-sm sm:order-none sm:w-auto"
      :class="{
        'sm:mx-auto': requestMetaStore.finalized,
        'sm:ml-auto': !requestMetaStore.finalized,
      }"
    >
      <template v-if="requestMetaStore.finalized" #icon-before>
        <IconSave class="size-4" />
      </template>
      Entwurf speichern
    </Button>

    <div class="empty:hidden" id="ownbit-configurator-stepper-footer"></div>
    <Button
      class="w-full sm:w-fit [:not(:empty)+&]:hidden"
      @click="stepsStore.goNext"
      theme="dark"
      :class="!stepsStore.hasNextStep && 'hidden sm:invisible sm:flex'"
    >
      Weiter
      <template #icon-after>
        <IconArrowRight />
      </template>
    </Button>
  </div>
</template>
